<div class="disclaimer" *ngIf="matIconName && message">
  <mat-icon style="color: black">{{ matIconName }}</mat-icon>
  <div class="message">{{ message }}</div>
</div>
